import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { Language } from "../../../utils";
import { user as userActions } from "../../../actions";
import makeClasses from "../styles";
import clsx from "clsx";
import { useState } from "react";
import Grid from "@material-ui/core/Grid";
import FileUploader from "../../../components/FileUploader";
import Button from "../../../components/Button";
import InformationTooltip from "../../../components/InformationTooltip";

const StepSeven = ({ nextStep, traceId, requiresPosExemption }) => {
  const dispatch = useDispatch();
  const classes = makeClasses();

  const [filesPosExemption, setFilesPosExemption] = useState([]);
  const [filesExemption, setFilesExemption] = useState([]);
  const [filesDGI, setFilesDGI] = useState([]);
  const [filesAnnex, setFilesAnnex] = useState([]);

  const { loading, languageTexts } = useSelector((state) => ({
    loading: state.user.loading,
    languageTexts: state.language.texts || {},
  }));

  const i18n = Language(languageTexts);

  const canMoveToNext = filesDGI.length > 0;

  const handleNext = () => {
    dispatch(
      userActions.merchantAffiliationUploadFiles(
        traceId,
        filesDGI,
        filesExemption,
        filesAnnex,
        filesPosExemption,
        (result) => {
          if (result === "ok") {
            nextStep();
          }
        },
      ),
    );
  };

  const handleFileChange = (files, setFile) => {
    setFile(files);
  };

  return (
    <React.Fragment>
      <div className={classes.formContent}>
        <div className={classes.formTitleContainer}>
          <div className={classes.formTitle}>
            {i18n.get("LegalEntityRegistration.StepFormTitle")}
          </div>
          <div className={classes.formText}>
            {i18n.get("LegalEntityRegistration.Step5FormText")}
          </div>
        </div>
        <form layout="vertical" onSubmit={handleNext} className={classes.form}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={6} xl={6}>
              <div className={classes.formInputTitleContainer}>
                <div className={classes.formInputTitle}>
                  {i18n.get("LegalEntityRegistration.DGIForm")}
                </div>
                <InformationTooltip title={i18n.get("LegalEntityRegistration.DGIFormTooltip")} />
              </div>

              <FileUploader
                onFileChange={(files) => handleFileChange(files, setFilesDGI)}
                title={i18n.get("LegalEntityRegistration.InputDGITitle")}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={6} xl={6}>
              <div className={classes.formInputTitleContainer}>
                <div className={classes.formInputTitle}>
                  {i18n.get("LegalEntityRegistration.WithholdingExemption")}
                </div>
                <InformationTooltip title={i18n.get("LegalEntityRegistration.WithholdingExemptionTooltip")} />
              </div>
              <FileUploader
                onFileChange={(files) =>
                  handleFileChange(files, setFilesExemption)
                }
                title={i18n.get("LegalEntityRegistration.InputDDJJTitle")}
                templatePath={"./template_ddjj_exoneraciones.pdf"}
                templateName="Plantilla-Exoneración-de-retenciones"
              />
            </Grid>
            {requiresPosExemption && (
              <Grid item xs={12} sm={12} md={6} xl={6}>
                <div className={classes.formInputTitleContainer}>
                  <div className={classes.formInputTitle}>
                    {i18n.get("LegalEntityRegistration.PosExemption")}
                  </div>
                  <InformationTooltip title={i18n.get("LegalEntityRegistration.PosExemptionTooltip")} />
                </div>
                <FileUploader
                  onFileChange={(files) =>
                    handleFileChange(files, setFilesPosExemption)
                  }
                  title={i18n.get(
                    "LegalEntityRegistration.InputPosExemptionTitle",
                  )}
                />
              </Grid>
            )}

            <Grid
              item
              xs={12}
              sm={12}
              md={requiresPosExemption ? 6 : 12}
              xl={requiresPosExemption ? 6 : 12}>
              <div className={classes.formInputTitleContainer}>
                <div className={classes.formInputTitle}>
                  {i18n.get("LegalEntityRegistration.Annex")}
                </div>
              </div>
              <FileUploader
                onFileChange={(files) => handleFileChange(files, setFilesAnnex)}
                title={i18n.get("LegalEntityRegistration.InputAnnexTitle")}
              />
            </Grid>
          </Grid>
        </form>
      </div>
      <div
        className={clsx(
          classes.formSubmitContainer,
          classes.formSubmitContainerWithOneButton,
        )}>
        <Button
          className={classes.formSubmitButton}
          disabled={loading || !canMoveToNext}
          onClick={handleNext}>
          {i18n.get("LegalEntityRegistration.NextButton")}
        </Button>
      </div>
    </React.Fragment>
  );
};
StepSeven.id = "com.Handy.LegalEntityRegistration.StepSeven";
export default StepSeven;
